import { List } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LegendListItem } from './LegendListItem';
import { LegendSectionTitle } from './LegendSectionTitle';

export const AirLegend = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <List
      disablePadding
      dense
      subheader={
        <LegendSectionTitle
          subtitle={t('map.legends.air.subtitle')}
          sx={(theme) => ({ lineHeight: theme.typography.pxToRem(16) })}
        >
          {t('map.legends.air.title')}
        </LegendSectionTitle>
      }
    >
      <LegendListItem
        primaryText={t('map.legends.air.legends.less50.title')}
        secondary={t('map.legends.air.legends.less50.subtitle')}
        iconColor="#64DB4B"
      />
      <LegendListItem
        primaryText={t('map.legends.air.legends.less100.title')}
        secondary={t('map.legends.air.legends.less100.subtitle')}
        iconColor="#FFFD3A"
      />
      <LegendListItem
        primaryText={t('map.legends.air.legends.less150.title')}
        secondary={t('map.legends.air.legends.less150.subtitle')}
        iconColor="#FF721F"
      />
      <LegendListItem
        primaryText={t('map.legends.air.legends.less200.title')}
        secondary={t('map.legends.air.legends.less200.subtitle')}
        iconColor="#FE0013"
      />
      <LegendListItem
        primaryText={t('map.legends.air.legends.less300.title')}
        secondary={t('map.legends.air.legends.less300.subtitle')}
        iconColor="#823989"
      />
      <LegendListItem
        primaryText={t('map.legends.air.legends.more300.title')}
        secondary={t('map.legends.air.legends.more300.subtitle')}
        iconColor="#720120"
      />
    </List>
  );
};
